import { __assign } from "tslib";
import React from 'react';
import InternalMultiselect from './internal';
var Multiselect = React.forwardRef(function (props, ref) {
    return React.createElement(InternalMultiselect, __assign({}, props, { ref: ref }));
});
export default Multiselect;
//# sourceMappingURL=index.js.map